import { Component, Input, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { SvgAvatarComponent } from "app/shared/components/svg/svg-avatar/svg-avatar.component";

@Component({
  selector: "avatar",
  templateUrl: "./avatar.component.html",
  styleUrls: ["./avatar.component.scss"],
  imports: [SvgAvatarComponent],
})
export class AvatarComponent implements OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  @Input() public userName?: string;
  @Input() public iconColor: string = "user-info__avatar--color";
  @Input() public bgColor: string = "user-info__avatar--bg-color";
  @Input() public e2e: string;

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
